import React from 'react';

import cn from 'classnames';
import { TFunction } from 'i18next';

import { Icon, MenuList, Popup } from '@shared/ui';

import cls from './AttachmentsList.module.css';
import { isAttachmentDTO, isClientAttachment } from '../../lib';
import { useAttachmentsList } from '../../lib/hooks';
import { getAttachmentMenu } from '../../model/menuData';
import { TAttachmentOnClient, TAttachmentId, TAttachmentDTOCamelCased } from '../../model/types';
import { FileItem } from '../FileItem';

interface IAttachmentsList {
    t: TFunction<'translation', undefined>;
    attachments: (TAttachmentOnClient | TAttachmentDTOCamelCased)[];
    onClickFileInput: () => void;
    onDeleteAttachment: (id: TAttachmentId) => void;
    maxAttachmentsLength?: number;
    isDisabled?: boolean;
}

export const AttachmentsList = ({
    t,
    attachments,
    onClickFileInput,
    onDeleteAttachment,
    maxAttachmentsLength = 10,
    isDisabled = false,
}: IAttachmentsList) => {
    const {
        toggleContextMenu,
        onDeleteAttachment: onDeleteAttachmentHandler,
        onDownloadAttachment,
        isOpenDeletePopup,
        handleOpenDeletePopup,
        anchorRefs,
        onHidePopup,
        openedMenuId,
        resetOpenMenuId,
        getAttachmentInfo,
    } = useAttachmentsList({ onDeleteAttachmentCb: onDeleteAttachment });
    return (
        <>
            <Popup
                isOpen={isOpenDeletePopup}
                onHidePopup={onHidePopup}
                contentText={t('Delete.return.ModalBody.confirmDelete')}
                type="delete"
                btnActionCb={onDeleteAttachmentHandler}
            />
            <ul className={cn(cls.AttachmentsList)}>
                {attachments.map((file) => {
                    if (!isClientAttachment(file) && !isAttachmentDTO(file)) return null;
                    const { fileImgUrl, isFileLoading, isImg, fileExtension, fileName } =
                        getAttachmentInfo(file);

                    return (
                        <FileItem
                            fileId={file.id}
                            key={file.id}
                            anchorRef={(el) => {
                                anchorRefs.current[file.id] = el;
                            }}
                            attachments={attachments}
                            fileName={fileName}
                            fileExtension={fileExtension}
                            isLoading={isFileLoading}
                            imgUrl={fileImgUrl}
                            isImage={isImg}
                            isContextMenuOpen={openedMenuId === file.id}
                            toggleContextMenu={() => toggleContextMenu(file.id)}
                            ContextMenu={
                                <MenuList
                                    menuData={getAttachmentMenu({
                                        fileId: file.id,
                                        handleDownload: () => {
                                            onDownloadAttachment(file);
                                        },
                                        handleDelete: () => handleOpenDeletePopup(file.id),
                                    }).filter((item) => !(item.id === 'delete' && isDisabled))} // фикс, чтобы запретить удалять файл, если есть флаг isDisabled
                                    isOpen={openedMenuId === file.id}
                                    onClose={resetOpenMenuId}
                                    anchorRef={{
                                        current: anchorRefs.current[file.id] || null,
                                    }}
                                />
                            }
                        />
                    );
                })}

                {attachments.length > 0 &&
                    attachments.length < maxAttachmentsLength &&
                    !isDisabled && (
                        <li onClick={onClickFileInput} className={cls.AddFileBtn}>
                            <Icon
                                iconName="fileInput"
                                className={cls.fileInputIcon}
                                width={26}
                                height={26}
                            />
                            <span className={cn(cls.AddFileTitle)}>
                                {t('Tasks.ModalFileUploader.DnD.AddFile.text')}
                            </span>
                        </li>
                    )}
            </ul>
        </>
    );
};
